import type { ReactNode } from 'react';

export const symbol_book_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M290-80q-53.86 0-91.93-38.07Q160-156.14 160-210v-540q0-53.86 38.07-91.93Q236.14-880 290-880h450q24.75 0 42.38 17.62Q800-844.75 800-820v515q0 9.14-5.5 16.57T781-277q-20 8-30.5 26.52Q740-231.95 740-210q0 21.09 10.5 39.55Q761-152 781-144q10 4 14.5 13.5T800-110q0 12.44-8.62 21.22Q782.75-80 770-80H290Zm-70-240q16-10 33.61-15t36.39-5h450v-480H290q-29.17 0-49.58 20.42Q220-779.17 220-750v430Zm203-191h113l20 56q2 7 7.5 11t13.5 4q12 0 19-10t2-21l-88-234q-2-7-8-11t-14-4h-18q-8 0-14 4t-8 11l-88 235q-5 11 2.5 20.5T382-440q8 0 13.5-4t7.5-11l20-56Zm14-41 41-116h3l40 116h-84ZM220-320v-500 500Zm69.54 180H699q-9-15-14-33t-5-37q0-20 5-37.5t15-32.5H289.61q-28.61 0-49.11 20.42Q220-239.17 220-210q0 29 20.5 49.5t49.04 20.5Z"
		/>
	</svg>
);
